<template>
  <section class="container">

    <div class="floor-breadcrumb">
      <el-breadcrumb class="hsb-breadcrumb" separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <!-- :to="reEvURI" -->
          <span class="custom-link" @click="$router.go(-2)">机况评估</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <!-- :to="reGetEvInfo" -->
          <span class="custom-link" @click="$router.go(-1)">获得报价</span>
        </el-breadcrumb-item>
        <el-breadcrumb-item>填写下单信息</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <el-form class="order-form" ref="orderForm" :rules="rules" :model="orderForm" :label-position="labelPosition">

      <!-- 选择回收方式 -->
      <el-form-item class="card-form-item recycle-types" label="回收方式">
        <radio
          class="text-center vivo-radio pc-type-radio recycle-type"
          v-model="orderForm.recycleType"
          :label="type.id"
          v-for="type in supportList.slice(0, 2)"
          :key="type.id"
          :data-type="type.id"
        >
          <img class="icon-bg" src="//www.huishoubao.com/www_fendi/new_PC/images/submit/shunfeng.png" v-if="type.id==1 || type.id==3">
          <img class="icon-bg" src="//www.huishoubao.com/www_fendi/new_PC/images/submit/shangmen.png" v-if="type.id==2">
          <div class="content">
            <p>{{ type.name }}</p>
            <p class="text-muted text-sz-descript">{{ type.desc }}</p>
          </div>
          <i class="icon hidden-xs"></i>
        </radio>
      </el-form-item>

      <!-- 填写个人信息 -->
      <FormContact :orderForm="orderForm" :validateField="validateField"></FormContact>

      <!-- 选择收款方式：当回收方式为上门回收时才展示 -->
      <FormPayType
        :payWayList="payWayList"
        v-model="orderForm.payType"
        v-if="isSM && isValidLoginState"
        @item-click="onPayTypeClick"
      >
        <div slot="bottom" v-if="currentTypeAuthInfo" style="margin-top: 15px;">
          <p clsss="auth-info" v-if="isWechat">您当前已经关联了上门回收微信收款账户：{{ currentTypeAuthInfo.nickname }}</p>
          <p clsss="auth-info" v-if="isAlipay">您当前已经关联了上门回收支付宝收款账户：
            <span v-if="currentTypeAuthInfo.nick_name">{{ currentTypeAuthInfo.nick_name }}</span>
            <img class="user-avatar" v-else-if="currentTypeAuthInfo.avatar" :src="currentTypeAuthInfo.avatar">
            <span v-else>您未设置昵称和头像，但是不影响使用</span>
          </p>
        </div>
      </FormPayType>

      <!-- 填写取件地址 -->
      <el-form-item class="bg-white form-item-card" label="地址信息" v-if="isSF || isSM">
        <span class="vivo-form-item-lable fl text-muted">取件地址</span>
        <el-form-item class="fl" prop="selectedSMCity" v-if="isSM" key="selectedSMCity" :rules="SMCityRule">
          <cascader
            placeholder="取件地址（市/区）"
            v-model="orderForm.selectedSMCity"
            name="selectedSMCity"
            @complated="validateField('selectedSMCity')"
            :options="smCtiys"
            :titles="['市', '区']"
            :props="{label: 'name', value: 'id', children: 'sub' }"></cascader>
        </el-form-item>
        <el-form-item class="fl" prop="selectedSFCity" v-if="isSF" key="selectedSFCity" :rules="SFCityRule">
            <cascader
              placeholder="取件地址（省/市/区）"
              v-model="orderForm.selectedSFCity"
              @complated="validateField('selectedSFCity')"
              name="selectedSFCity"
              :options="sfCtiys"
              :titles="['省', '市', '区']"
              :props="{label: 'areaName', value: 'areaName', children: 'children' }"></cascader>
          </el-form-item>
        <el-form-item class="fl" prop="address" v-if="isSF || isSM">
          <h-input placeholder="填写您的详细地址，详细到门牌号" v-model.trim="orderForm.address" @input="validateField('address')"></h-input>
        </el-form-item>
        <div class="fl clearfix mt-base" v-if="isSF || isSM">
          <span class="vivo-form-item-lable fl text-muted"> 交易时间</span>
          <el-form-item
            class="fl"
            prop="selectedTimes"
            v-if="isSF || isSM"
          >
            <cascader
              placeholder="选择上门时间"
              name="sftime"
              v-model="orderForm.selectedTimes"
              @complated="validateField('selectedTimes')"
              :options="sfSupportVisitTime"
              :props="{label: 'name', value: 'name', children: 'sub' }"
              :titles="['日期', '时间']"></cascader>
          </el-form-item>
        </div>
      </el-form-item>

      <!-- 选择加价券 -->
      <el-form-item class="bg-white form-item-card coupon-form-item" :class="{'is-open': couponVisible}">
        <div slot="label">
          <span>加价券</span>
          <div class="fr coupon-header text-muted pointer" @click="couponVisible = !couponVisible">
            <span v-if="!orderForm.selectedCouponId[0]">{{ hasCoupon ? '选择用券' : '暂无可用券'}}</span>
            <span v-else>已加价 <span class="text-danger">{{ selectedCoupon.couponValue | fen2yuan }}</span></span>
            <i class="el-icon-arrow-down"></i>
          </div>
        </div>
        <div class="coupons-lg" v-show="couponVisible">
          <coupon v-for="item in couponList" :key="item.couponId" class="pointer" :disabled="item.isCanUse !== '1'" :coupon="item" select-mode v-model="orderForm.selectedCouponId[0]"></coupon>
        </div>
        <el-form-item class="fl">
          <label class="name-label">加价券</label>
          <cascader :placeholder="hasCoupon ? '选择用券' : '暂无可用券'" class="coupon-wraper visible-xs-block" :popoverVisible.sync="casPopoverVisible" can-cancel :auto-close="false" v-model="orderForm.selectedCouponId" name="selectedCouponId" :label-formatter="labelFormatter" :options="couponList" :props="{label: 'couponName', value: 'couponId'}">
            <div slot-scope="{ label }" slot="label" class="text-right text-muted"><span v-html="label"></span> <i class="el-icon-arrow-right label-icon"></i> </div>
            <div slot-scope="{ item }" slot="item">
              <coupon :coupon="item" select-mode v-model="orderForm.selectedCouponId[0]" :disabled="item.isCanUse !== '1'"></coupon>
            </div>
            <div slot="header" class="cascader-header">
                选择加价券
                <i class="el-icon-close fr" @click="casPopoverVisible = false"></i>
            </div>
          </cascader>
        </el-form-item>
      </el-form-item>

      <!-- 解锁指导-->
      <el-form-item class="bg-white form-item-card unlock hidden-xs" label="解锁">
        <p class="text-muted mb-base">请解除开机密码并且手动注销iCloud账户，以确保您的隐私安全和顺利质检；对于未解锁手机，回收宝将拒签退回。</p>
        <popover v-model="popupVisbile" :append-to-body="true" visible-arrow>
          <a href="javascript:;" slot="reference" @click="popupVisbile = true">如何解锁 <i class="el-icon-question"></i></a>
          <div>
            <p>
              Q: iPhone如何取消开机密码<br>
              A: 设置——Touch ID和密码——点击关闭密码<br>
              Q: iPhone如何关闭iCloud<br>
              A: 设置——进入iCloud——注销——从我的iPhone删除——输入密码——删除<br>
            </p>
          </div>
        </popover>
      </el-form-item>

      <p class="use-wallet-tip" v-if="!isSM">备注：完成订单后，会打款到您的回收宝钱包，可随时提现</p>

      <!-- 提交订单 -->
      <el-form-item class="submit-action">
        <div class="fr">
          <div class="bottom-price fr">
            <h-button
              type="danger"
              round
              :disabled="submitting || !agree || !userInfo.tel || !isValidLoginState || !orderForm.payType"
              @click="createHsbpcOrder"
              class="vivo-submit fr"
            >
              <span>提交订单</span>
            </h-button>
          </div>
          <checkbox class="fr" v-model="agree" style="margin-top: 5px; margin-right: 8px;">
            <span class="text-muted">我已经阅读并同意</span>
            <!-- <span @click.stop.prevent="dialogVisible = true">《回收宝服务条款》</span> -->
            <a href="https://mobile.huishoubao.com/mobile/m/www_term_of_service.html" class="protocol-link">《服务条款》</a>
            <span class="text-muted">和</span>
            <a href="https://mobile.huishoubao.com/mobile/m/privacy_protocol.html" class="protocol-link">《隐私协议》</a>
          </checkbox>
        </div>
      </el-form-item>
    </el-form>

    <EvaInfo class="side-info"
      :evInfo="evInfo"
      :activeList="activeList"
      :selectedCoupon="selectedCoupon"
      :totalPrice="totalPrice"></EvaInfo>

    <el-dialog :visible.sync="dialogVisible" class="contract-dialog">
      <hsb-service></hsb-service>
    </el-dialog>

    <el-dialog class="scan-code-dialog" :visible.sync="scanCodeDialogVisible">
      <p class="title" slot="title">
        <span v-show="isAlipay">请用支付宝扫码收款</span>
        <span v-show="isWechat">请用微信扫码收款</span>
      </p>
      <p v-show="isWechat" style="margin-bottom: 10px">您当前的手机号码: {{ orderForm.tel }}尚未绑定微信</p>
      <img :src="scanCodeUri">
      <p class="desc" v-show="isAlipay">交易成功后，请到该支付宝账号： <span>我的-余额</span> 中查收款项</p>
      <p class="desc" v-show="isWechat">交易成功后, 请到已绑定微信账号: <span> 我-钱包-零钱 中查收款项</span></p>
    </el-dialog>
  </section>
</template>

<script>
import { fen2yuan } from '@/helper/filters';
import initOrderCore from '@/core/initOrder/index';
import evStore from '@/core/ev-info/store';
import HsbService from '@/core/common-ui/service/hsb';
import { Breadcrumb, BreadcrumbItem, Message } from 'element-ui';
import { getCacheInfoByTel, getOauthCodeUri, checkLoginStatus } from '@/apis/base';
import hsbLogin from '@/core/login/hsbLogin';
import EvaInfo from './EvaInfo';
import FormPayType from './FormPayType';
import FormContact from './FormContact';

const ALIPAY = 'alipay';
const WECAHT = 'wechat';

const OAUTH_REDIRECT_URL_MAP = {
  [WECAHT]: 'https://mobile.huishoubao.com/static/m/common/html/wxauth.html',
  [ALIPAY]: 'https://mobile.huishoubao.com/static/m/common/html/alipay.html'
};

const cacheKeys = [
  'orderForm.tel',
  'orderForm.userName',
  'orderForm.address',
  'orderForm.selectedSFCity',
  'orderForm.selectedSMCity'
];

export default {
  extends: initOrderCore,
  mixins: [hsbLogin],
  asyncData (...arg) {
    return initOrderCore.asyncData(...arg);
  },
  registerModule (store, preserveState) {
    store.registerModule('initOrder', evStore, { preserveState });
  },
  destroyed () {
    this.$store.unregisterModule('initOrder');
  },
  components: {
    HsbService,
    [Breadcrumb.name]: Breadcrumb,
    [BreadcrumbItem.name]: BreadcrumbItem,
    FormPayType,
    EvaInfo,
    FormContact
  },
  data () {
    return {
      casPopoverVisible: false,
      labelPosition: 'top',
      popupVisbile: false,
      dialogVisible: false,
      couponVisible: false,
      typesOpening: false,
      scanCodeDialogVisible: false,
      scanCodeUri: '',
      [ALIPAY]: '',
      [WECAHT]: '',
      wechatInfo: null,
      alipayInfo: null,
      timeId: '',
      isValidLoginState: false
    };
  },
  computed: {
    supportList () {
      return this.recycleList.filter(item => this.supportVist(item));
    },
    vivoCounpon () {
      return this.evInfo.thirdCoupons || {};
    },
    totalAll () {
      return this.totalPrice + this.vivoCounpon.amount;
    },
    otherForm () {
      return {
        thirdCouponId: this.vivoCounpon.id
      };
    },
    userInfo () {
      return this.$store.state.user.userInfo;
    },
    selectedOption () {
      return this.evInfo.selectParams.map(item => item.optionValueId);
    },
    reEvURI () {
      return `/evaluate/${this.evInfo.productId}.html?selecteds=${JSON.stringify(this.selectedOption)}`;
    },
    reGetEvInfo () {
      return `/evInfo/${this.evInfo.evaluateid}?selecteds=${JSON.stringify(this.selectedOption)}`;
    },
    isAlipay () {
      return this.orderForm.payType === this.Q_CONST.PAY_TYPE.Alipay;
    },
    isWechat () {
      return this.orderForm.payType === this.Q_CONST.PAY_TYPE.WeChat;
    },
    currentType () {
      if (this.isAlipay) return ALIPAY;
      if (this.isWechat) return WECAHT;
    },
    currentTypeAuthInfo () {
      return this[this.currentType + 'Info'];
    }
  },
  watch: {
    loginSmsCode (val) {
      if (val.length === 6) {
        this.doLogin();
      }
    },
    userInfo (val) {
      if (val && val.tel) {
        this.orderForm.tel = val.tel;
        this.updateLoginState();
      }
    },
    'orderForm.recycleType' (val) {
      if (!this.isSM) {
        // 不是上门回收时, 使用回收宝钱包收款
        this.orderForm.payType = this.Q_CONST.PAY_TYPE.HsbWallet;
      } else {
        if (this.orderForm.payType === this.Q_CONST.PAY_TYPE.HsbWallet) {
          // 让用户自己选择收款方式
          this.orderForm.payType = '';
        }
      }
      this.loadCoupon();
    },
    scanCodeDialogVisible (val) {
      if (!val) {
        try {
          clearTimeout(this.timeId);
        } catch (e) {
          console.log(e);
        }
      }
    }
  },
  cacheKeys: cacheKeys,
  methods: {
    createHsbpcOrder () {
      const recycleMap = {
        '1': 'sfCallinrecycle',
        '2': 'callIndetectrecycle'
      };
      this.$store.commit('report/reportHandle', { event: 'placeOrder',
        custom: {
          recycle_type: recycleMap[this.orderForm.recycleType]
        } });
      if (!this.orderForm.payType) {
        return Message.error('请选择收款方式');
      }
      if (this.isSM && !this.currentTypeAuthInfo) {
        this.onPayTypeClick();
      } else {
        this.createOrder();
      }
    },
    updateLoginState () {
      checkLoginStatus().then(res => {
        if (res.success) {
          this.isValidLoginState = +res._data.status === 1;
        } else {
          Message.error(res._errStr);
        }
      }).catch(err => {
        Message.error(err);
      });
    },
    async onPayTypeClick () {
      if (!this.isValidLoginState) return;
      if (!this.userInfo.tel) return;
      if (!this.currentTypeAuthInfo) {
        try {
          await this.updateAuthInfo(this.currentType);
          if (!this.currentTypeAuthInfo) {
            this.getOauthScanCode();
            this.startPoll();
          }
        } catch (e) {
          // 获取授权信息报错
          Message.error(e);
        }
      }
    },
    labelFormatter (item) {
      return `已加价<span class="text-danger">${fen2yuan(item.couponValue)}</span>`;
    },
    loginAfter (token, userInfo) {
      if (userInfo) {
        this.$store.commit('user/setUserInfo', {
          tel: userInfo.tel,
          openid: userInfo.openid
        });
      }
      this.$store.commit('user/setToken', token, this.expires);
    },
    getOauthScanCode () {
      this.scanCodeUri = getOauthCodeUri(
        this.orderForm.tel,
        this.currentType,
        encodeURIComponent(OAUTH_REDIRECT_URL_MAP[this.currentType])
      );
      this.scanCodeDialogVisible = true;
    },
    async updateAuthInfo (type) {
      let res = await getCacheInfoByTel(this.orderForm.tel, type);
      if (res.success) {
        if (type === ALIPAY && res._data.user_id) {
          this.alipayInfo = res._data;
          this.scanCodeUri = '';
          this.scanCodeDialogVisible = false;
          this.orderForm.payAccount = res._data.user_id;
          this.orderForm.payName = res._data.nick_name;
        }
        if (type === WECAHT && res._data.openid) {
          this.wechatInfo = res._data;
          this.scanCodeUri = '';
          this.scanCodeDialogVisible = false;
          this.orderForm.payAccount = res._data.openid;
          this.orderForm.payName = res._data.nickname;
        }
      } else {
        Message.error(`获取回收信息错误: ${res._errStr}`);
        throw res._errStr;
      }
    },
    async startPoll () {
      await this.updateAuthInfo(this.currentType);
      if (!this.currentTypeAuthInfo) {
        this.timeId = setTimeout(() => {
          this.startPoll();
        }, 1500);
      }
    }
  },
  mounted () {
    if (this.userInfo.tel) {
      this.orderForm.tel = this.userInfo.tel;
    }
    this.updateLoginState();
  }
};
</script>

<style scoped src="./index.css"></style>



// WEBPACK FOOTER //
// src/projects/hsbpc/views/createOrder/index.vue